import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Row, Col, Spin, Form, Input, Space, Switch } from 'antd';
import PageContent from '../../structure/PageContent';
import { useI18nLocalization } from '../../i18nLocalization/useI18nLocalization';

const UserProfile = () => {
	const user = useSelector((state) => state.user);
	const roles = useSelector((state) => state.company?.roles ?? []);

	const { t } = useI18nLocalization();

	return !user ? (
		<Row justify='center' align='middle' style={{ height: '100%' }}>
			<Col>
				<Spin />
			</Col>
		</Row>
	) : (
		<>
			<PageContent>
				<Form layout='vertical' scrollToFirstError>
					<Row gutter={[16, 0]}>
						<Col span={24} lg={{ span: 12 }}>
							<Form.Item label={t('First Name')}>
								<Input
									disabled
									className='darken-disabled-text'
									placeholder={t('first name')}
									value={user.profile.firstName}
								/>
							</Form.Item>
						</Col>
						<Col span={24} lg={{ span: 12 }}>
							<Form.Item label={t('Last Name')}>
								<Input
									disabled
									className='darken-disabled-text'
									placeholder={t('last name')}
									value={user.profile.lastName}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[16, 0]}>
						<Col span={24} lg={{ span: 12 }}>
							<Form.Item label={t('Email Address')}>
								<Input
									disabled
									className='darken-disabled-text'
									placeholder={t('email address')}
									value={user.profile.emailAddress}
								/>
							</Form.Item>
						</Col>
						<Col span={24} lg={{ span: 12 }}>
							<Form.Item label={t('Employee Id')}>
								<Input
									disabled
									className='darken-disabled-text'
									placeholder='employee id'
									value={user.profile.employeeId}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={[16, 0]}>
						<Col span={24} lg={{ span: 12 }}>
							<Form.Item label='OID'>
								<Input disabled className='darken-disabled-text' placeholder='oid' value={user.profile.oid} />
							</Form.Item>
						</Col>
						<Col span={24} lg={{ span: 12 }}>
							<Form.Item label={t('Security Id')}>
								<Input
									disabled
									className='darken-disabled-text'
									placeholder={t('security id')}
									value={user.profile.objectSid}
								/>
							</Form.Item>
						</Col>
					</Row>
					<Form.Item label={t('Job Title')}>
						<Input disabled className='darken-disabled-text' placeholder='job title' value={user.profile.jobTitle} />
					</Form.Item>
					<Form.Item label={t('Roles')}>
						<RoleList roles={roles} userRoleIds={user.roles.map((r) => r.roleId)} />
					</Form.Item>
					<Form.Item label={t('Active')}>
						<Switch checked={user.profile.userEnabled} disabled />
					</Form.Item>
				</Form>
			</PageContent>
		</>
	);
};

//-- Need to do this beceause the validator requires an onChange event be on the top-most element of Form.Input
const RoleList = ({ roles, userRoleIds }) => {
	const sortedRoles = _.orderBy(roles, ['name'], ['asc']);
	const { t } = useI18nLocalization();
	return (
		<Space direction='vertical'>
			{_.map(sortedRoles, (sr) => {
				return (
					<Space key={sr.id} direction='horizontal'>
						<Switch checked={userRoleIds.includes(sr.id)} disabled />
						<span>
							{sr.name} <i>({t(sr.description)})</i>
						</span>
					</Space>
				);
			})}
		</Space>
	);
};

RoleList.propTypes = {
	roles: PropTypes.array.isRequired,
	userRoleIds: PropTypes.array.isRequired
};

export default UserProfile;
